<template>
    <div class="editPassword">
        <div class="title">密码修改</div>
        <div class="content">
            <div class="item">
                <div class="item-t">原密码</div>
                <div class="item-i">
                    <el-input v-model="oldpwd" placeholder="请输入原密码" type="password"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="item-t">新密码</div>
                <div class="item-i">
                    <el-input v-model="newpwd" placeholder="请输入新密码" type="password"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="item-t">确认新密码</div>
                <div class="item-i">
                    <el-input v-model="newpwd2" placeholder="请再次输入确认新密码" type="password"></el-input>
                </div>
            </div>
        </div>
        <div class="btns">
            <el-button type="primary" @click="editPassword">确认修改</el-button>
        </div>
    </div>
</template>

<script>
import api from '../../../api/main'

export default {
    name: 'editPassword',
    data () {
        return {
            newpwd:'',
            oldpwd:'',
            newpwd2:'',
        }
    },
    created(){
    },
    mounted(){
        
    },
    computed:{
        
    },
    watch:{
        
    },
    methods:{
        async editPassword(){
            if(this.newpwd != this.newpwd2){
                this.$message.error('两次密码输入不一致！');
                return;
            }
            let res = await api.updatePassword({
                newPassword: this.newpwd,
                oladPassword: this.oldpwd,
            });
            console.log(res);
            if(res.data.code == '200'){
                this.$message({
                    message: '修改成功',
                    type: 'success'
                });
            }
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
    .editPassword{
        background-color: #ffffff;
        border-radius: 4px;
        padding-left: 40px;
        .title{
            color: #515a6e;
            font-weight: bold;
            font-size: 20px;
            padding: 20px 15px;
        }
        .content{
            padding-left: 30px;
            padding-bottom: 10px;
            .item{
                margin-bottom: 20px;
                .item-t{
                    font-size: 15px;
                    color: #515a6e;
                    font-weight: bold;
                    margin-bottom: 12px;
                }
                .item-i{
                    width: 400px;
                }
            }
        }
        .btns{
            width: 430px;
            display: flex;
            flex-direction: row-reverse;
            padding-bottom: 30px;
        }
    }
</style>

